import type { FC } from "react";

import type { FontVariant } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

import { StyledTextOverflow } from "app/pages/sales-intelligence/common-components/OverflowTooltip/styles";
import { useIsTextTruncated } from "app/pages/sales-intelligence/hooks/useIsTextTruncated";

interface Props {
    text: string;
    fontVariant: FontVariant;
    color: string;
    disabled?: boolean;
    dataAutomation?: string;
}

export const OverflowTooltip: FC<Props> = ({ text, fontVariant, color, disabled, dataAutomation }) => {
    const { ref: textRef, isTruncated } = useIsTextTruncated(text);

    return isTruncated && !disabled ? (
        <Tooltip
            placement="top-start"
            content={text}
        >
            <StyledTextOverflow
                fontVariant={fontVariant}
                color={color}
            >
                {text}
            </StyledTextOverflow>
        </Tooltip>
    ) : (
        <StyledTextOverflow
            ref={textRef}
            fontVariant={fontVariant}
            color={color}
            data-automation={dataAutomation}
        >
            {text}
        </StyledTextOverflow>
    );
};
